import { render, staticRenderFns } from "./UserPublicPage.vue?vue&type=template&id=633663d5&scoped=true"
import script from "./UserPublicPage.vue?vue&type=script&lang=js"
export * from "./UserPublicPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633663d5",
  null
  
)

export default component.exports